<template>
  <div class="statistics-item-outer">
    <div class="icon">
      <img :src="iconSrc" alt="">
    </div>
    <div class="meta-info">
      <div class="title">{{title}}(<span class="unit">{{unit}}</span>)</div>
      <div class="num">{{num}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    iconSrc:String,
    unit:String,
    title:String,
    num:Number,
  }
}
</script>

<style lang="scss" scoped>
.statistics-item-outer{
  display: flex;
  width: 250px;
  height: 80px;
  align-items: center;
  background: url('~@/assets/images/bg_icon.png') center center / cover no-repeat;
  padding: 5px 10px;
  box-sizing: border-box;
  margin: 10px 15px 0 0;
  &:last-child{
    margin-right: 0;
  }
  .meta-info{
    margin-left: 10px;
  }
  .title{
    font-size: 14px;
    color: #fff;
  }
  .num{
    margin-top: 10px;
    color:var(--color);
    font-size: 24px;
    font-weight: bold;
  }
}
</style>